 <div class="row wide-bg d-flex justify-content-center inner-wrapper" [style.height]="'500px'" [style.backgroundRepeat]="'no-repeat'" [style.backgroundPosition]="'center'"
      [style.background-image]="this.bgImageUrl ? 'url(' + this.bgImageUrl + ')' : ''">
   <div class="col-lg-8" style="width: 400px;flex: none; padding: 0">
     <div class="m-content form-block">
       <div class="row">
         <div class="col-sm-12 login-box">
           <div>
             <div>
               <h1 class="login-page-title accent-text ">
                 {{'WELCOME' | dictionary}}
               </h1>
             </div>
             <div class="pt-0 pb-0" style="padding:0;">
               <form (submit)="login()">
                 <div class="m-portlet__body">
                   <div class="form-group text-center" style="margin: 0;">
                     <button type="submit"
                             class="button-1">
                       {{'SIGN_IN' | dictionary}}
                     </button>&nbsp;&nbsp;
                   </div>
                   <div class="form-group home-box-small-text ">
                     <span class="form-text text-center tiny-note-color">
                       {{'NOT_YET_REGISTERED' |dictionary}}
                       <a style="font-weight: 600; text-decoration: underline; background-color: #FFFF00" href="javascript:void(0);" class="link-2"
                          (click)="tryToNavigate('/registration-investor')">{{'REGISTER' | dictionary}}</a><br>
                       {{'IF_YOU_ADVISOR' |dictionary}}
                       <a style="font-weight: 600; text-decoration: underline; background-color: #FFFF00" href="javascript:void(0);" class="link-2"
                          (click)="tryToNavigate('/registration-rep')"
                       >{{'REGISTER' | dictionary}}</a>
                       <br *ngIf="showProxyLink">
                       <br *ngIf="showProxyLink">
                       <span style="font-weight: 600; font-size: larger" *ngIf="showProxyLink">{{'CLICK_HERE' | dictionary}} <a [routerLink]="['/proxy']"
                         style="font-weight: 600; font-size: larger; text-decoration: underline; background-color: #FFFF00" class="link-2"
                       >{{'PROXY_VOTING' | dictionary}}</a></span>

                       <br *ngIf="showLoginMessage">
                       <br *ngIf="showLoginMessage">
                        <span *ngIf="showLoginMessage">
                          <div [innerHTML]="loginMessage"></div>
                        </span>
                      </span>
                   </div>
                 </div>
               </form>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
   <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm($event)">
   </app-pop-up-dialog>
 </div>
 <div class="footer-wrapper">
   <img class="footer" *ngIf="footerImage" [src]="footerImage"  (error)="handleMissingImage($event)"/>
 </div>
  <div>
    <span class="build-version justify-content-center" *ngIf="buildVersion">REV: {{buildVersion}}</span>
    <span> 
        <a style="font-weight: 200; color: grey;" href="javascript:void(0);" (click)="loginVistra()">Internal Use</a><br><br>
    </span>
  </div>

